function restoreImport(uri, mediaQuery) {
  return ('@import ' + uri + ' ' + mediaQuery).trim();
}

module.exports = restoreImport;



//////////////////
// WEBPACK FOOTER
// ./node_modules/clean-css/lib/reader/restore-import.js
// module id = 294
// module chunks = 0 1